import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/movies";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % total), 6000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (dir: number) => setIndex((i) => (i + dir + total) % total);

  return (
    <section className="relative w-full h-[460px] md:h-[620px] overflow-hidden bg-background-100">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.seq}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
          aria-hidden={i !== index}
        >
          <img
            src={slide.image}
            alt={`《色戒》主题海报 - ${slide.title}`}
            title="色戒 在线观看"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/55 to-background-50/25" />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50/85 via-background-50/30 to-transparent" />
        </div>
      ))}

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-center">
        <div className="w-full max-w-3xl">
          {heroSlides.map((slide, i) =>
            i === index ? (
              <div key={slide.seq} className="animate-fade-up">
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/90 text-primary-950 text-xs font-medium">
                  <i className="ri-fire-fill" />
                  {slide.tag}
                </span>
                <h1 className="mt-4 font-heading text-3xl md:text-6xl font-bold text-foreground-950 leading-tight">
                  {slide.title}
                </h1>
                <p className="mt-3 md:mt-4 text-sm md:text-lg text-foreground-700 max-w-xl">{slide.subtitle}</p>
              </div>
            ) : null
          )}

          <div className="mt-6 md:mt-9 flex flex-wrap items-center gap-3">
            <Link
              to="/watch"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-foreground-950 font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg" />
              立即观看（演示）
            </Link>
            <Link
              to="/story"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-md bg-background-100/90 border border-background-300 text-foreground-950 font-medium hover:border-accent-500 transition-colors backdrop-blur-sm whitespace-nowrap"
            >
              <i className="ri-book-open-line text-lg" />
              查看剧情介绍
            </Link>
          </div>
        </div>
      </div>

      <button
        onClick={() => go(-1)}
        aria-label="上一张"
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center rounded-full bg-background-100/80 border border-background-300 text-foreground-950 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-left-s-line text-xl" />
      </button>
      <button
        onClick={() => go(1)}
        aria-label="下一张"
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center rounded-full bg-background-100/80 border border-background-300 text-foreground-950 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-right-s-line text-xl" />
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.seq}
            onClick={() => setIndex(i)}
            aria-label={`切换到第 ${i + 1} 张`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-8 bg-accent-500" : "w-3 bg-background-400 hover:bg-background-500"
            }`}
          />
        ))}
      </div>
    </section>
  );
}